import { useEffect, useRef } from 'react';
import { trackTimeOnPage } from '../utils/analytics';

/**
 * Hook pour tracker le temps passé sur une page
 * @param {string} pageName - Le nom de la page à tracker
 * @param {boolean} enabled - Si le tracking est activé
 */
export const useTimeTracker = (pageName, enabled = true) => {
  const startTimeRef = useRef(Date.now());
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    startTimeRef.current = Date.now();

    // Envoyer le temps toutes les 30 secondes
    intervalRef.current = setInterval(() => {
      const timeSpent = (Date.now() - startTimeRef.current) / 1000; // en secondes
      trackTimeOnPage(pageName, timeSpent);
    }, 30000); // Toutes les 30 secondes

    // Envoyer le temps total quand l'utilisateur quitte la page
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      
      const totalTimeSpent = (Date.now() - startTimeRef.current) / 1000;
      if (totalTimeSpent > 0) {
        trackTimeOnPage(pageName, totalTimeSpent);
      }
    };
  }, [pageName, enabled]);
};


